/* eslint-disable max-lines */
/* eslint-disable xss/no-mixed-html */
/* eslint-disable complexity*/
ACC.quickOrder = {
  invalidProdDiv: 'ph-invalidproductdiv',
  placeHolderProd: 'ph-quickorders__prodplaceholder',
  wrongproddiv: 'ph-wrongprod',
  prodidAttr: '.product_id',
  wrongOrangeproddiv: 'ph-error-red',
  qualityQuickOrd: '.ph-quickorder__quantity',
  quantityInvalidCls: '.ph-prodqtyinvalid',
  inputId: '',
  bindAll: function() {
    var inputQtyClass = 'ph-quickorders__qtyplaceholder input',
        placeHolderProd = ACC.quickOrder.placeHolderProd,
        orderRow = 'orders__rows';

    $('.' + inputQtyClass).unbind();
    $(document).on('blur', '.ph-quickorders__productvalue', function() {
      var $row = $(this).closest('.ph-quick' + orderRow),
          prodCode = $(this).val(),
          prodObject = {
            $prodCode: prodCode
          };

      prodObject.$productParent = $row.find('.' + placeHolderProd);
      prodObject.$prodCode = prodCode;
      prodObject.$prodTitle = prodObject.$productParent.find('.ph-formlabel');
      prodObject.$errorField = $row.find('.ph-prodcodeinvalid');
      prodObject.$prodCross = prodObject.$productParent.find('.ph-icon-close.ph-quickorder');
      prodObject.$prodExclamation = prodObject.$productParent.find('.ph-exclamation-mark');
      prodObject.$prodCheck = prodObject.$productParent.find('.ph-icon-checkmark');
      prodObject.$placeholder = prodObject.$productParent.attr('data-placeholder');
      prodObject.$qtyErrorParentdiv = $row.find('.ph-qtyerrmsg-parent');

      if (prodObject.$prodCode === '') {
        $row.find('.ph-invalid-resp-messg').addClass('hidden');
        $row.find('.ph-not-avail-msg').addClass('hidden');
        $row.find('.ph-leftover-avail-msg').addClass('hidden');
        $row.find('.ph-prod-url').html('');
        $row.find('.ph-pritemlists').html('');
        ACC.quickOrder.productFailed(prodObject, 'emptycode');
      } else {
        ACC.quickOrder.productSuccess(prodObject);
      }
    });

    $(document).on('blur', '.ph-quickorder__quantity', function() {
      var $row = $(this).closest('.ph-quick' + orderRow),
          prodCode = $(this).val(),
          prodObject = {
            $productParent: ''
          };

      prodObject.$productParent = $row.find('.ph-quickorders__qtyplaceholder');
      prodObject.$errorField = $row.find(ACC.quickOrder.quantityInvalidCls);
      prodObject.$qtyErrorParentdiv = $row.find('.ph-qtyerrmsg-parent');
      $row.find('.ph-importinvalidqty').css('display', 'none');
      $(this).removeClass('ph-qtyerror-import');
      $('.ph-product-code-label').removeClass('ph-qtylabel-import');

      if (prodCode === '' || prodCode <= 0) {
        ACC.quickOrder.qtyFailed(prodObject, 'emptyqty');
      } else if (isNaN(prodCode)) {
        ACC.quickOrder.qtyFailed(prodObject, 'notNumber');
      } else {
        ACC.quickOrder.productSuccess(prodObject);
      }

      ACC.quickOrder.enableDisableButton($(this));
    });
  },
  addremove: function(obj) {
    obj.$errorField.addClass(ACC.quickOrder.wrongproddiv);
    obj.$prodCross.removeClass('hidden ph-crossemptycode');
    obj.$prodExclamation.addClass('hidden');
    obj.$prodExclamation.removeClass('ph-exclamationemptycode ph-exclamationinvalidcode');
  },
  productFailed: function(obj, item) {
    var invalidProdDiv = ACC.quickOrder.invalidProdDiv,
        invalidmsgClasses = ACC.quickOrder.wrongproddiv + ' ' + ACC.quickOrder.wrongOrangeproddiv;

    ACC.quickOrder.addremove(obj);
    obj.$errorField.html($('.ph-errormessages').attr('data-' + item)).addClass(invalidmsgClasses);
    obj.$prodTitle.html(obj.$placeholder);
    obj.$prodCheck.addClass('hidden');
    obj.$prodCross.removeClass('hidden');
    obj.$prodCross.addClass('ph-cross' + item);
    obj.$productParent.addClass(invalidProdDiv);
    obj.$prodExclamation.addClass('ph-exclamation' + item);
  },
  productSuccess: function(obj) {
    var invalidProdDiv = ACC.quickOrder.invalidProdDiv;

    obj.$errorField.html('').removeClass(ACC.quickOrder.wrongproddiv);
    obj.$productParent.removeClass(invalidProdDiv);
    obj.$qtyErrorParentdiv.addClass('hidden');
  },
  qtyFailed: function(obj, item) {
    var invalidProdDiv = ACC.quickOrder.invalidProdDiv,
        invalidClasses = ACC.quickOrder.wrongproddiv + ' ' + ACC.quickOrder.wrongOrangeproddiv;

    obj.$errorField.html($('.ph-errormessages').attr('data-' + item)).addClass(invalidClasses);
    obj.$productParent.addClass(invalidProdDiv);
    obj.$qtyErrorParentdiv.removeClass('hidden');
  },
  validateQuickOrder: function(data) {
    var isValid = true,
        nullrow = '';

    if (data.$row.length > 0) {
      $('.ph-nullrow').remove();
      data.$row.each(function() {
        ACC.quickOrder.validateqo($(this));
      });
    } else {
      nullrow = '<div class="ph-nullrow"></div>';
      $('.ph-quickorders__addrowparent').before(nullrow);
    }

    if ($('.ph-invalidproductdiv').length > 0 || $('.ph-nullrow').length > 0) {
      isValid = false;
    }

    if (isValid) {
      if (data.isSpQuickOrder === 'true' && data.clearCartFlag === 'true') {
        ACC.quickOrder.changeAcknowledgePopup($('#quickOrderForm'));
      } else {
        $('#quickOrderForm').submit();
      }
    }
  },
  validateqo: function($row) {
    var valid = true,
        trimmedProduct = $.trim($($row).find(ACC.quickOrder.prodidAttr).val()),
        trimmedQty = $.trim($($row).find('.product_quantity').val());

    if (trimmedProduct !== '') {
      if (trimmedQty === '') {
        valid = ACC.quickOrder.showError($row, 'quantity');
      }
    } else if (trimmedQty !== '') {
      if (trimmedProduct === '') {
        valid = ACC.quickOrder.showError($row, 'product');
      }
    } else if (trimmedProduct === '' && trimmedQty === '') {
      $($row).find('.ph-invalidproductdiv').removeClass('ph-invalidproductdiv');
    }

    return valid;
  },
  showError: function($row, item) {
    var invalidProdDiv = ACC.quickOrder.invalidProdDiv,
        errormsgdiv = 'ph-errormessages',
        placeHolderProd = ACC.quickOrder.placeHolderProd;

    if (item && item === 'quantity') {
      $row.find(ACC.quickOrder.quantityInvalidCls).addClass(ACC.quickOrder.wrongproddiv).html($('.' + errormsgdiv).attr('data-emptyqty'));
      $row.find('.ph-quickorders__qtyplaceholder').addClass(invalidProdDiv);
    } else if (item && item === 'product') {
      $row.find('.ph-prodcodeinvalid').addClass(ACC.quickOrder.wrongOrangeproddiv).html($('.' + errormsgdiv).attr('data-emptycode'));
      $row.find('.' + placeHolderProd).addClass(invalidProdDiv);
    }

    return false;
  },
  disableButtonIfErrorsExist: function(isError) {
    var addtoCartBtnCls = '.ph-quick-order-button',
        enableBtnCls = 'ph-orangebutton',
        disableBtnCls = 'ph-disable-button';

    if (isError || $('.ph-disablebutton').length > 0 || $('.ph-interstitial-loader:visible').length > 0) {
      $(addtoCartBtnCls).removeClass(enableBtnCls).addClass(disableBtnCls);
    } else if ($('.ph-sap-orderBlock').length === 0 && $('.ph-prodstock-avail:visible').length === 0) {
      $(addtoCartBtnCls).removeClass(disableBtnCls).addClass(enableBtnCls);
    } else {
      $(addtoCartBtnCls).removeClass(enableBtnCls).addClass(disableBtnCls);
    }

    ACC.quickOrder.zoomMixCartButtonDisable();
  },
  /* eslint-disable max-len*/
  checkForItemLevelError: function() {
    var isBackorderEnabled = $('#nobackorderset').val(),
        noAvailMsg = '.ph-not-avail-msg:visible',
        qtyInvalidMsg = '.ph-prodqtyinvalid:visible',
        popUpMsg = '.ph-stockinfo:visible',
        popupQtyMsg = '.ph-stockinfo-common:visible',
        invalidResMsg = '.ph-invalid-resp-messg:visible';

    if (isBackorderEnabled === 'true') {
      if ($(noAvailMsg).length > 0 || $(qtyInvalidMsg).length > 0 || $(popUpMsg).length > 0 || $(invalidResMsg).length > 0 || $(popupQtyMsg).length > 0) {
        ACC.quickOrder.disableButtonIfErrorsExist(true);
      } else {
        ACC.quickOrder.disableButtonIfErrorsExist(false);
      }
    } else if ($(qtyInvalidMsg).length > 0 || $(invalidResMsg).length > 0 || $(popUpMsg).length > 0 || $(popupQtyMsg).length > 0) {
      ACC.quickOrder.disableButtonIfErrorsExist(true);
    } else {
      ACC.quickOrder.disableButtonIfErrorsExist(false);
    }
  },
  /* eslint-enable max-len*/
  enableDisableButton: function(thisVal, availstatus) {
    var quantityDisable = '',
        orengebut = 'ph-orangebutton',
        disbutton = 'ph-disable-button',
        quickbutton = '.ph-quick-order-button',
        prodCode = thisVal;

    if (prodCode.val() === '' || prodCode.val() <= 0 || isNaN(prodCode.val()) || availstatus === 'red') {
      quantityDisable = $(quickbutton).removeClass(orengebut).addClass(disbutton);
    } else if ($('.ph-sap-orderBlock').length === 0) {
      quantityDisable = $(quickbutton).removeClass(disbutton).addClass(orengebut);
    } else {
      quantityDisable = $(quickbutton).removeClass(orengebut).addClass(disbutton);
    }

    ACC.quickOrder.checkForItemLevelError();

    if ($('.ph-disablebutton').length > 0 || $('.ph-interstitial-loader:visible').length > 0) {
      quantityDisable = $(quickbutton).removeClass(orengebut).addClass(disbutton);
    }

    ACC.quickOrder.zoomMixCartButtonDisable();

    return quantityDisable;
  },
  zoomMixCartButtonDisable: function() {
    var addtoCartBtnCls = '.ph-quick-order-button',
        enableBtnCls = 'ph-orangebutton',
        disableBtnCls = 'ph-disable-button',
        hiddenElems = $(document).find('.ph-quickorders__rows .product-hidden-code'),
        regularCount = 0,
        zoomDeliveredCount = 0;

    $(addtoCartBtnCls).removeAttr('iszoomdelivered');
    $('.zoom_mixcart_error').addClass('hidden');
    hiddenElems.each(function() {
      var $elmnt = $(this),
          qtyInputBox = $elmnt.parents('.ph-quickorders__rows').find('.product-quantity');

      qtyInputBox.removeAttr('readonly').prop('readonly', false);

      if ($elmnt.val() !== '' && $elmnt.attr('iszoomdelivered') === 'true') {
        zoomDeliveredCount = zoomDeliveredCount + 1;
        qtyInputBox.prop('readonly', true);
        qtyInputBox.val($('.zoomDeliveredQty').text());
        $(addtoCartBtnCls).attr('iszoomdelivered', 'true');
      } else if ($elmnt.val() !== '') {
        regularCount = regularCount + 1;
      }
    });

    if ((zoomDeliveredCount > 0 && regularCount > 0) || zoomDeliveredCount > 1) {
      $(addtoCartBtnCls).removeClass(enableBtnCls).addClass(disableBtnCls);
      $('.zoom_mixcart_error').removeClass('hidden');
    }
  }
};


$(document).ready(function() {
  var quickRow = 'quickorders__rows';

  $('#importOrderForm #fileImport').bind('input', function() {
    $('.uploadBtn').submit();
  });

  $(document).on('click', '.ph-quickorders__clearall', function() {
    $.ajax({
      url: ACC.config.encodedContextPath + '/quickOrder/removeAllEntries',
      type: 'GET',
      datatype: 'json',
      success: function() {
        window.location.replace(ACC.config.encodedContextPath + '/quickOrder');
      }
    });
  });

  ACC.quickOrder.bindAll();
  ACC.quickOrder.zoomMixCartButtonDisable();
  $(document).on('click', '.ph-icon-close.ph-quickorder-pop', function() {
    $('.ph-quickorders__text3').addClass('hidden');
  });
  $(document).on('click', '.ph-uploadfile', function() {
    var emptCart = 'emptyCart';
    var data = {
      isSpQuickOrder: $(this).attr('data-spOrder'),
      clearCartFlag: $(this).attr('data-' + emptCart)
    };

    if (data.isSpQuickOrder === 'true' && data.clearCartFlag === 'true') {
      ACC.quickOrder.changeAcknowledgePopup($(this).parents('.ph-importorders__uploadfile'));
    } else {
      $(this).parents('.ph-importorders__uploadfile').submit();
    }
  });

  $('.ph-' + quickRow).find('input, textarea, select').focus(function() {
    $(this).parent().addClass('ph-focusing');
  }).blur(function() {
    $(this).parent().removeClass('ph-focusing');
  });

  $(document).on('click', '#ph-quickordercontainer .ph-quickOrder-excel', function() {
    $('.ph-togglequick-first').addClass('hidden');
    $('.ph-quickOrder-importExcel').removeClass('hidden');
  });

  $(document).on('click', '#ph-quickordercontainer .ph-quickOrder-addProduct-manual', function() {
    $('.ph-togglequick-first').removeClass('hidden');
    $('.ph-quickOrder-importExcel').addClass('hidden');
  });

  /* Commenting this function as this functionality already exists in PE-Modules.js in line no 1850
  $(document).on('click', '.ph-quickOrder-excel-btn-import', function() {
    $('#fileImport').click();
  });
  */

  $(document).on('click', '.ph-quickOrder-excel-btn', function() {
    $('#ph-quickOrder-download').click();
  });
});

$(document).ready(function() {
  $('.phi-calenderdatepicker').change(function() {
    var $calenderFromValue = $('.ph-fromdate');
    var $calenderToValue = $('.ph-todate');
    var fromDate = $calenderFromValue.val();
    var toDate = $calenderToValue.val();

    $('input[name="orderCreatedFromDate"]').val(fromDate);
    $calenderFromValue.attr('value', fromDate);
    $calenderFromValue.val(fromDate);
    $calenderToValue.attr('value', toDate);
    $calenderToValue.val(toDate);
    $('input[name="orderCreatedToDate"]').val(toDate);
  });

  $('.phi-submitform').click(function() {
    var orderCreatedToDate = $('.ph-todate').val();
    var orderCreatedFromDate = $('.ph-fromdate').val();

    if (orderCreatedToDate === orderCreatedFromDate) {
    /* eslint-disable no-alert*/
      alert('Dates can not be equal');

      /* eslint-enable no-alert*/
      return false;
    }

    return true;
  });
  $(document).on('keyup', '.ph-quickorders__rows .product-code', function() {
    ACC.quickOrder.inputId = $(this).attr('id');
  });

  $(document).on('click', '.ph-quicklist ul.ui-autocomplete .product', function() {
    /* Not used as commenting the focus event to avoid retrigerring quickorderresponse api
     var quickRow = 'quickorders__rows';

    $('#' + ACC.quickOrder.inputId).trigger('change'); */
    // $('#' + ACC.quickOrder.inputId).parents('.ph-' + quickRow).find('.ph-quickorders__qtyplaceholder input').focus();
    ACC.quickOrder.inputId = '';
  });
});

/* eslint-enable complexity*/
/* eslint-enable xss/no-mixed-html */
/* eslint-enable max-lines */
